export default {
  successPage: {
    title: '資料提出成功',
    label: 'お申込みいただき、ありがとうございました。コンプライアンス手続きしますので、完了次第メールで連絡致します。'
  }
}
